"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var data = [{
  title: 'Ant Design Title 1'
}, {
  title: 'Ant Design Title 2'
}, {
  title: 'Ant Design Title 3'
}, {
  title: 'Ant Design Title 4'
}];
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.List, {
    itemLayout: "horizontal",
    dataSource: data,
    renderItem: function renderItem(item) {
      return /*#__PURE__*/_react.default.createElement(_antd.List.Item, null, /*#__PURE__*/_react.default.createElement(_antd.List.Item.Meta, {
        avatar: /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
          src: "https://joeschmoe.io/api/v1/random"
        }),
        title: /*#__PURE__*/_react.default.createElement("a", {
          href: "https://ant.design"
        }, item.title),
        description: "Ant Design, a design language for background applications, is refined by Ant UED Team"
      }));
    }
  });
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: [],
  key: 'default'
};
var _default = exports.default = componentDemo;